export default "__VITE_ASSET__f7e0fcff__"